import { atom, useRecoilValue, useSetRecoilState, selector } from 'recoil';

export const ChatbotError = {
  WelcomeError: 'WelcomeError',
  FirstInteractionError: 'FirstInteractionError',
  NextInteractionError: 'NextInteractionError',
  InChatInteractionError: 'InChatInteractionError',
};

/**
 * chatbot error scenario
 */
const chatbotErrorState = atom({
  key: 'chatbotError',
  default: '',
});

export const useChatbotError = () => useRecoilValue(chatbotErrorState);

export const useSetChatbotError = () => useSetRecoilState(chatbotErrorState);

const isChatbotWelcomeError = selector({
  key: 'isChatbotWelcomeError',
  get: ({ get }) => get(chatbotErrorState) === 'chatBotWelcomeError',
});

export const useIsChatbotWelcomeError = () =>
  useRecoilValue(isChatbotWelcomeError);
